export default "__VITE_ASSET__BPyrtGu6__"